import i18n from 'i18next'

/**
 * Locale for date, time and number formatting in the interface language the user chose (#1416).
 * Without it, `toLocale*String()` follows the browser language and `'de-DE'` ignores the choice.
 */
export function uiLocale(language: string | undefined = i18n.resolvedLanguage ?? i18n.language): string {
  return language?.toLowerCase().startsWith('de') ? 'de-DE' : 'en-US'
}
